import { IValidationParamsErrorPayload } from 'onboarding/types/request'

/**
 * Converts the ValidationError[](from server) into a string with a list of errors to display
 */
export const convertErrorMessagesToHTMLList = (
  values: (IValidationParamsErrorPayload | string)[] | string
): string => {
  if (typeof values === 'string') {
    return values
  }

  return `<ul>${(values as Array<IValidationParamsErrorPayload | string>).reduce<string>(
    (accumulator, value) => {
      if (typeof value === 'string') {
        return accumulator + `<li>${value}</li>`
      } else {
        return accumulator + `<li>${value.message}</li>`
      }
    },
    ''
  )}</ul>`
}
